import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import GeometricOverlay from "./GeometricOverlay";
import WordFadeIn from "./WordFadeIn";
import DrawIcon from "./DrawIcon";

const AboutSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id="ueber-uns" ref={ref} className="relative py-20 md:py-32 px-6 md:px-16 overflow-hidden" aria-label="Über uns">
      <GeometricOverlay />

      {/* Decorative drawn heart */}
      <DrawIcon
        variant="heart"
        size={180}
        delay={0.5}
        className="absolute left-1/2 -translate-x-1/2 md:left-auto md:translate-x-0 md:right-16 top-20 z-10 opacity-15"
      />

      <div className="relative z-20 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-start">
        <div className="text-center md:text-left">
          <p className="font-body text-sm text-primary-bright tracking-[0.3em] uppercase mb-4">
            Über uns
          </p>
          <WordFadeIn
            text="Familie, Team und über *40* *Jahre* Handelserfahrung"
            as="h2"
            className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-foreground leading-tight [hyphens:none]"
            staggerDelay={0.12}
            highlightPrimary
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            animate={isInView ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="mt-10 overflow-hidden border border-border"
          >
            <img
              src="/images/inhaber-familie.webp"
              alt="Inhaber Peter Kotlarski mit seiner Frau im Obst- und Gemüsebereich"
              className="w-full aspect-[3/2] object-cover object-center"
              loading="lazy"
            />
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, x: 40 }}
          animate={isInView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="space-y-6 text-center md:text-left"
        >
          <p className="text-muted-foreground font-body text-lg leading-relaxed max-w-xl mx-auto md:mx-0">
            Rewe Kotlarski ist ein kleiner Markt mit familiärer Atmosphäre, in dem jeder Kunde willkommen ist. Peter Kotlarski, seine Frau, seine Tochter und das gesamte Team stehen für ein persönliches Miteinander.
          </p>
          <p className="text-muted-foreground font-body text-lg leading-relaxed max-w-xl mx-auto md:mx-0">
            Peter Kotlarski ist seit 1982 bei REWE tätig und seit 2001 selbstständiger Inhaber. Diese langjährige Erfahrung verbindet fundierte Handelskenntnis mit einer familiären Unternehmensstruktur.
          </p>
          <div className="flex justify-center md:justify-start gap-8 md:gap-12 pt-4">
            <div>
              <p className="font-display text-3xl md:text-4xl font-bold text-primary-bright">26</p>
              <p className="text-muted-foreground font-body text-sm mt-1">Mitarbeitende</p>
            </div>
            <div>
              <p className="font-display text-3xl md:text-4xl font-bold text-primary-bright">40+</p>
              <p className="text-muted-foreground font-body text-sm mt-1">Jahre Erfahrung</p>
            </div>
            <div>
              <p className="font-display text-3xl md:text-4xl font-bold text-primary-bright">seit 2001</p>
              <p className="text-muted-foreground font-body text-sm mt-1">selbstständig</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;